declare const API_CONFIG: 'dev' | 'test' | 'uat' | 'prod';

export const GLOBAL_ENV = API_CONFIG;

// 官网后台Appid
export const appId = 'JZFZ_OFFICIAL_WEBSITE_APPID';


// 环境枚举
export enum EnvEnum {
	DEV = 'dev',	// 开发
	TEST = 'test',	// 测试
	UAT = 'uat',	// 预发布
	PROD = 'prod',	// 生产
}

// 官网所有跳转地址配置
export const WEBSITE_PATHS = {
    home: '/home',                                  // 首页
    aboutUs: '/aboutUs',                            // 关于
	aboutUsPublicize: '/aboutUsPublicize',			// 关于我们，基准方中宣传广告页
    product: '/product',                            // 作品，产品
    service: '/service',                            // 服务
    news: '/news',                                  // 新闻动态
    joinUs: 'https://jzfz.zhiye.com/',              // 招聘<外接链接>
    read: '/read',                                  // 阅读
    periodical: '/periodical',                      // 基准之道
    aesthetice: '/aesthetice',                      // 视觉美学
    contactUs: '/contactUs',                        // 联系我们
    noticeList: '/noticeList',                      // 公告列表
    noticeInfo: '/noticeInfo',                      // 公告详情
    search: '/search',                              // 搜索结果
	integrityInquiry: '/integrity',					// 贪腐解聘查询
};


// 官网后台管理所有跳转地址配置
export const WEBSITE_CMS_PATHS = {
	home: '/',                                                  // 首页轮播大图配置
    aboutUs: '/aboutUs',                                        // 关于                                      
    product: '/product',                                        // 项目作品管理
	service: '/service',                                        // 服务
    news: '/news',                                              // 新闻动态管理   
    aesthetics: '/aesthetics',                                  // 视觉美学
    periodical: '/periodical',                                  // 基准之道
    notice: '/notice',                                          // 通知公告
    contactUs: '/contactUs',                                    // 联系我们
};

// 模块类型枚举
export enum ModuleTypeEnum {
	// ############以下后端定义#############
    PROJECT = 'PROJECT', 										// 项目作品
    NEWS = 'NEWS', 												// 新闻动态
    AESTHETICS = 'VISUAL_AESTHETICS', 							// 视觉美学
    PERIODICAL = 'PERIODICAL', 									// 基准之道
    NOTICE = 'ANNOUNCEMENT', 									// 通知公告
    CONTACT = 'CONTACT', 										// 联系我们
    // ############以下前端自定义#############
    BANNER = 'BANNER', 											// 首页banner管理
    ABOUT = 'ABOUT', 											// 关于
    SERVICE = 'SERVICE', 										// 服务
};


// 图片格式数组
export const IMG_FOMARTS = [
	// "image/png",
	// "image/jpeg",
	// "image/gif",
	// "image/svg+xml",
	"image/webp",
	// "image/bmp",
	// "image/tiff",
	// "image/x-icon",
	// "image/vnd.microsoft.icon",
	// "image/heic",
	// "image/heif",
	// "image/avif"
];


// 公司信息
export const companyInfo = {
	name: '成都基准方中科技有限公司',
	// logo
	logo: require('../assets/images/official-website-icon.png'),
	// 电话
	phone: '13575461107',
	// 邮箱
	email: 'leadgital001@163.com',
	// 邮编
	zipCode: '610000',
	// 地址
	address: '四川省成都市成华区仙韵一路450号',
	// 网址
	webURL: 'www.leadgital.cn',
	// ICP备案号
	icpNO: '蜀ICP备2023015192号-1',
	// ICP备案号链接
	icpURL: 'https://beian.miit.gov.cn',
	// 公安备案链接
	policeURL: 'http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=51010802001400',
	// 公安备案图标
	policeIcon: require('../assets/images/beian.png'),
	// 公安备案号
	policeNO: '川公网安备 51010802001400号',
	// 公司微信公众号
	wechatQRCode: require('../assets/images/qr_code.jpg'),
	// 微信咨询号
	wechatConsultQRCode: require('../assets/images/contact_qrcode.jpg'),
};












// ###### 华丽的分界线，以下暂未使用 ##########################################################################


// 专业枚举
export enum MajorEnum {
	ALL = '',   // 所有专业
	C = 'C', // 创意
	A = 'A', // 建筑
	S = 'S', // 结构
	E = 'E', // 电气
	P = 'P', // 给排水
	M = 'M', // 暖通
	W = 'W', // 幕墙
	L = 'L', // 景观
	I = 'I', // 室内
	B = 'B', // 经济
	G = 'G', // 规划
	X = 'X', // 项目管理
	Z = 'Z', // 其它
	Y = 'Y',  // 待整理资料
	T = 'T', // 通用
}


// 模块类型
export enum ModuleEnum {
	help = 0,   // 帮助
	typical = 1,    // 典型问题
	rules = 2,  // 规定问题
	standard = 3,   // 国家规范
	learn = 4,  // 学习资料
	standardTask = 5,   // 标准任务
	standardMap = 6,    // 标准图集
	attachment = 8,    // 附件
	exam = 10,  // 考试
	dwgMaterial = 11, // 建筑节点
	dwgPlane = 12,  // 建筑平面
	projectStep = 74,   // 工程做法
	dwgScheme = 13, // 精品方案库
	dwgLib = 14,    // 图纸库
	dwgElevator = 15,   // 建筑电梯
	dwgMarketing = 16,  // 技术营销
	projectSummary = 17,  // 项目总结
	technicalReport = 18,  // 技术汇报
	HVACDwgMaterial = 19,   // 暖通节点
	electricalMaterial = 20,    // 电气样图节点
	structNodeMaterial = 21, // 结构样图节点
	plumbingMaterial = 22, // 给排水节点库
	projectMsgManage = 60,  // 项目信息管理
};


// 题库目录类型
export enum ExamQuestionCatalogTypeEnum {
	'CATALOG' = 'CATALOG',  // 目录
	'QUESTION' = 'QUESTION' // 题目
}

// 审核状态
export const auditStatusEnum = {
	1: '草稿',
	2: '待提交',
	3: '待审核',
	4: '待修改',
	5: '未采纳',
	6: '挂起',
	7: '已通过',
}

// 问题等级
export const levelOptions = [
	{label: '轻微', value: 1},
	{label: '一般', value: 2},
	{label: '重要', value: 3},
	{label: '重大', value: 4},
	{label: '重大(强条)', value: 5},
]


// 问题类型枚举
export enum QuestionTypeEnum {
	TURE_FALSE = 'TURE_FALSE',   // 判断
	SINGLE_ANSWER = 'SINGLE_ANSWER', // 单选
	MULTIPLE_ANSWER = 'MULTIPLE_ANSWER', // 多选
}


// 规定问题客户类型枚举
export const CustomerTypeEnum = {
	COMPANY_REGULATION: 'COMPANY_REGULATION',   // 公司规定问题
	COOPERATE_KEY_POINT: 'COOPERATE_KEY_POINT', // 协作要点
}

// 富文本编辑器中允许粘贴的图片地址后缀
const editorImageHostSuffix = {
	dev: ['.jzfz.local'],
	test: ['.jzfz.local'],
	uat: [],
	pro: ['192.168.249.238'],
}
export const EDITOR_VALID_IMAGE_HOST_SUFFIX = editorImageHostSuffix[GLOBAL_ENV];

// 系统管理员名称
export const ADMIN_NAME = '系统管理员';

// 允许的图片格式
export const ALLOWED_IMAGE_FORMATS = '.webp';
